export default __webpack_public_path__ + "static/media/examplePhoto.f34a3c23.svg";